// extracted by mini-css-extract-plugin
export default {"thumbnailContainer":"Thumbnail_thumbnailContainer__vnTaL","timeLabel":"Thumbnail_timeLabel__O74zj"};